import { connect } from "react-redux";
import { ComplianceConfirmationComponent } from "./ComplianceConfirmation";
import { getOrgKYCDetails, getRoDocuments } from "../../../../../../store/selectors/appConfig";
import { updateProspect, updateRoProspect } from "../../../../../../store/actions/appConfig";

const mapStateToProps = state => ({
  orgKYCDetails: getOrgKYCDetails(state),
  roDocuments: getRoDocuments(state)
});

const mapDispatchToProps = {
  updateProspect,
  updateRoProspect
};

export const ComplianceConfirmation = connect(
  mapStateToProps,
  mapDispatchToProps
)(ComplianceConfirmationComponent);
